import React from 'react';
import { MessageCircle } from 'lucide-react';
import { trackWhatsAppClick } from '../utils/analytics';

interface WhatsAppButtonProps {
  phoneNumber: string;
  message?: string;
  className?: string;
  size?: 'small' | 'medium' | 'large';
  variant?: 'floating' | 'inline' | 'footer';
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({
  phoneNumber,
  message = "Hallo! Ich interessiere mich für Ihre Angebote.",
  className = "",
  size = "medium",
  variant = "inline"
}) => {
  // Telefonnummer formatieren (Leerzeichen und Sonderzeichen entfernen)
  const formatPhoneNumber = (phone: string) => {
    return phone.replace(/\D/g, '').replace(/^0/, '49');
  };

  const formattedPhone = formatPhoneNumber(phoneNumber);
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${formattedPhone}?text=${encodedMessage}`;

  const sizeClasses = {
    small: 'px-3 py-2 text-sm',
    medium: 'px-4 py-3 text-base',
    large: 'px-6 py-4 text-lg'
  };

  const variantClasses = {
    floating: 'fixed bottom-6 right-6 z-50 rounded-full shadow-lg hover:shadow-xl',
    inline: 'rounded-lg shadow-md hover:shadow-lg',
    footer: 'rounded-md'
  };

  const baseClasses = `
    inline-flex items-center justify-center gap-2
    bg-green-500 hover:bg-green-600 text-white font-medium
    transition-all duration-300 transform hover:scale-105
    ${sizeClasses[size]} ${variantClasses[variant]} ${className}
  `;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={baseClasses}
      title="WhatsApp kontaktieren"
      onClick={() => trackWhatsAppClick(`whatsapp_button_${variant}`)}
    >
      <MessageCircle className={`${size === 'small' ? 'w-4 h-4' : size === 'large' ? 'w-6 h-6' : 'w-5 h-5'}`} />
      <span>WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;